import { device } from "../../constants/mediaQueries";
import { useMediaQuery } from "../../utils/style/useMediaQuery";

interface PaddingValues {
  padTop: string;
  padBot: string;
  padLeft: string;
  padRight: string;
}

export function useLayoutPadding(
  extraPadding: boolean,
  zeroPadding: boolean,
  hasTopBar: boolean,
  hasMessageTop: boolean
): PaddingValues {
  const slonk = useMediaQuery(device.slonk);
  const sm = useMediaQuery(device.sm);
  const md = useMediaQuery(device.md);
  const xl = useMediaQuery(device.xl);
  const xxl = useMediaQuery(device.xxl);
  const chonk = useMediaQuery(device.chonk);

  const isSlonkRange = slonk && !sm;
  const isSmRange = sm && !md;
  const isMdRange = md && !xl;
  const isXlRange = xl && !xxl;
  const isXxlRange = xxl && !chonk;
  const isChonkRange = chonk;

  function getPadding() {
    if (zeroPadding) {
      return {
        padTop: "0px",
        padBot: "0px",
        padLeft: "0px",
        padRight: "0px",
      };
    }

    // iframe usually don't have topbar
    if (!hasTopBar) {
      return {
        padTop: "1rem",
        padBot: "1rem",
        padLeft: "1rem",
        padRight: "1rem",
      };
    }

    /////////////////////////////

    if (extraPadding) {
      if (isChonkRange) {
        return {
          padTop: "4.5rem",
          padBot: "2rem",
          padLeft: "6rem",
          padRight: "6rem",
        };
      }

      if (isXxlRange) {
        return {
          padTop: "3.5rem",
          padBot: "2rem",
          padLeft: "4rem",
          padRight: "4rem",
        };
      }

      if (isXlRange) {
        return {
          padTop: "3.5rem",
          padBot: "2rem",
          padLeft: "3rem",
          padRight: "3rem",
        };
      }

      if (isMdRange) {
        return {
          padTop: "2.5rem",
          padBot: "1rem",
          padLeft: "1rem",
          padRight: "1rem",
        };
      }

      if (isSmRange) {
        return {
          padTop: "1.5rem",
          padBot: "1rem",
          padLeft: "1rem",
          padRight: "1rem",
        };
      }

      if (isSlonkRange) {
        return {
          padTop: "1.5rem",
          padBot: "1rem",
          padLeft: "0.75rem",
          padRight: "0.75rem",
        };
      }

      // slinky
      return {
        padTop: "1rem",
        padBot: "1rem",
        padLeft: "0.5rem",
        padRight: "0.5rem",
      };
    }

    /////////////////////////////

    if (isChonkRange) {
      return {
        padTop: "2rem",
        padBot: "1rem",
        padLeft: "3rem",
        padRight: "3rem",
      };
    }

    if (isXxlRange) {
      return {
        padTop: "2rem",
        padBot: "1rem",
        padLeft: "2rem",
        padRight: "2rem",
      };
    }

    if (isXlRange) {
      return {
        padTop: "2rem",
        padBot: "1rem",
        padLeft: "2rem",
        padRight: "2rem",
      };
    }

    if (isMdRange) {
      return {
        padTop: "2rem",
        padBot: "1rem",
        padLeft: "1rem",
        padRight: "1rem",
      };
    }

    if (isSmRange) {
      return {
        padTop: "1.5rem",
        padBot: "1rem",
        padLeft: "1rem",
        padRight: "1rem",
      };
    }

    if (isSlonkRange) {
      return {
        padTop: "1.5rem",
        padBot: "1rem",
        padLeft: "0.5rem",
        padRight: "0.5rem",
      };
    }

    // slinky
    return {
      padTop: "1.5rem",
      padBot: "1rem",
      padLeft: "0.25rem",
      padRight: "0.25rem",
    };
  }

  const padding = getPadding();

  return {
    ...padding,
    padTop: hasMessageTop ? "0px" : padding.padTop,
  };
}
